import routes from '../../../routes';
import { isDevEnvironment } from '../../../utilities/env';

// Inline helper to avoid circular dependency with navigationUtils on storybook
const removeTrailingSlash = urlPath => (urlPath.endsWith('/') ? urlPath.slice(0, -1) : urlPath);

export const FLOW_NAVIGATION_ACTIONS = {
  FLOW_TRIGGER_NEXT_STEP: 'flow.navigateToNextStep',
  FLOW_TRIGGER_PREVIOUS_STEP: 'flow.navigateToPreviousStep',
  FLOW_TRIGGER_FIRST_STEP: 'flow.navigateToFirstStep',
  FLOW_TRIGGER_LAST_STEP: 'flow.navigateToLastStep',
  FLOW_TRIGGER_STEP_BY_SLUG: 'flow.navigateToStepBySlug'
};

export const STALE_TIME_LIMIT = 5 * 60 * 1000; // 5 minutes in milliseconds

export const MAX_RETRIES = 5;

export const FLOW_NAMES = {
  BOOKING: 'booking',
  BIRTHDAY: 'birthday',
  DAYPASS: 'daypass',
  MODIFY: 'modify'
};

/**
 * LOCAL ONLY: Maps flow names to their associated routes for local development.
 * This is used exclusively in development to determine the current flow from the URL.
 * In production, the flow name is injected via AEM HTML (data-flow attribute),
 * so this mapping will be an empty object.
 */

export const DEV_FLOW_NAME_TO_ROUTES = isDevEnvironment
  ? {
    [FLOW_NAMES.BOOKING]: [
      removeTrailingSlash(routes.plan.self),
      routes.plan.activities,
      routes.plan.dining,
      routes.plan.payment
    ],
    [FLOW_NAMES.BIRTHDAY]: [
      routes.birthdayParties.partySelect,
      routes.birthdayParties.foodDrinks,
      routes.birthdayParties.packagesAddons,
      routes.birthdayParties.guestInfo,
      routes.birthdayParties.payment
    ],
    [FLOW_NAMES.MODIFY]: [
      routes.reservations.myReservations.modify.suites,
      routes.reservations.myReservations.modify.activities,
      routes.reservations.myReservations.modify.dining,
      routes.reservations.myReservations.modify.payment
    ]
  }
  : {};
